import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MODAL_TOKEN, ModalProvider } from '@core';

@Component({
  selector: 'lib-push-comments-penalties ',
  templateUrl: './push-comments-penalties.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushCommentsPenaltiesComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
